import { ApiService} from '../../services'
import router from '../../router'
import { logout } from '../../helpers/user';
/* const userData = getUserData();

const initUserState = userData.user ? userData.data : {user_id : null , token : null} */

export const AuthModule = {
    namespaced : true,
    state : {
        user : null,
        loading : false
    },
    actions : {
        async login({state,commit},form){
            return await new Promise((resolve,reject) => {
                const loading = state.loading;
                
                if(!loading){
                    commit('LoadingTrue')
                    const params = {
                        email : form.email,
                        password : form.password,
                        location : form.showroom,
                        origin : 'fw'
                    }
                    ApiService.login(params).then((response) => {
                        console.log("response",response)
                        commit('initUserData', response.data)
                        commit('LoadingFalse');
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async generate({state,commit},form){
            return await new Promise((resolve,reject) => {
                const loading = state.loading;
                
                if(!loading){
                    commit('LoadingTrue')
                    const params = {
                        email : form.email,
                        password : form.password,
                        location : form.showroom,
                    }
                    ApiService.login(params).then((response) => {
                        console.log("response",response)
                        commit('initUserData', response.data)
                        commit('LoadingFalse');
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },

        async Logout({commit, dispatch}){
            return await new Promise(() => {
                logout();
                commit('ClearUserData');
                commit('CartModule/setCartData', null, { root: true });
                dispatch('CartModule/createCart', null, { root: true });

                router.push({ name: 'login'}).catch(() => { });
            })
            
        },

        
        
    },
    mutations : {
        initUserData(state,payload){
            state.user = payload
        },
        LoadingFalse(state){
            state.loading = false
        },
        LoadingTrue(state) {
            state.loading = true
        },
        ClearUserData(state){
            state.user = null
        }
    },
    getters : {
        user : state => state.user,
        Loading : state => state.loading,
    }
}
